import { Dictionary } from '@utils/util.types';
import i18next from 'i18next';
import * as Yup from 'yup';

const { t } = i18next;

export type termOption = {
	id: string;
	name: string;
	termsData?: any;
};

// export type CropID = {
// 	id: string;
// 	name: string;
// 	fee: number;
// 	currency?: string;
// };

export type PackagesFormValues = {
	crop: any;
	communication_language: Dictionary[];
	crop_area: string;
	crop_unit: Dictionary;
	latitude: number;
	longitude: number;
	crop_location_name: string;
	package_type: 'Standard' | 'Premium' | null;
};

export const cropUnitOptions: Dictionary[] = [
	{ name: t('unitTypes.m2'), id: 'm2' },
	{ name: t('unitTypes.hectares'), id: 'hectares' },
	{ name: t('unitTypes.acres'), id: 'acres' },
];

export const termsOptions: termOption[] = [
	{ name: 'servicePrice', id: 'price' },
	{ name: 'serviceDuration', id: 'duration' },
	{ name: 'numberOfPhases', id: 'phases' },
];

export const validationSchema = Yup.object({
	crop_location_name: Yup.string().required('Crop Location is required'),
	latitude: Yup.number(),
	longitude: Yup.number(),
	package_type: Yup.string().oneOf(['Standard', 'Premium']).required('Package type is required'),
	communication_language: Yup.array().min(1, 'Minimum one language is required'),
	crop: Yup.object().required('Crop is required'),
	crop_area: Yup.string().required('Crop Area is required'),
	crop_unit: Yup.object().required('Crop Unit is required'),
});

export type LocationCoordinates = {
	lat: number;
	lng: number;
};
